import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import App from "./App";
import Anmelden from "./seiten/Anmelden";
import Suche from "./seiten/Suche";
import PersonSeite from "./seiten/Person";
import StammbaumSeite from "./seiten/Stammbaum";
import FotoSeite from "./seiten/Foto";
import OrteSeite from "./seiten/Orte";
import KarteSeite from "./seiten/Karte";
import MedienSeite from "./seiten/Medien";
import BenutzerSeite from "./seiten/Benutzer";
import MeinZugangSeite from "./seiten/MeinZugang";
import EinladungSeite from "./seiten/Einladung";
import "./index.css";

const client = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: false } },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={client}>
      <BrowserRouter>
        <Routes>
          {/* ausserhalb des Rahmens, damit die Anmeldung ohne Sitzung erreichbar ist */}
          <Route path="/anmelden" element={<Anmelden />} />
          {/*
            Auch ausserhalb: wer sein Passwort erst setzt, HAT noch keine
            Sitzung. Im Rahmen wuerde ihn der Zugangsschutz sofort zur
            Anmeldung schicken - und dort kaeme er ohne Passwort nicht
            weiter. Eine geschlossene Tuer mit dem Schluessel davor.
          */}
          <Route path="/einladung/:token" element={<EinladungSeite />} />
          <Route element={<App />}>
            <Route index element={<Navigate to="/suche" replace />} />
            <Route path="suche" element={<Suche />} />
            <Route path="person/:id" element={<PersonSeite />} />
            <Route path="baum/:id" element={<StammbaumSeite />} />
            <Route path="foto/:id" element={<FotoSeite />} />
            <Route path="orte" element={<OrteSeite />} />
            <Route path="karte" element={<KarteSeite />} />
            <Route path="medien" element={<MedienSeite />} />
            <Route path="benutzer" element={<BenutzerSeite />} />
            <Route path="zugang" element={<MeinZugangSeite />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
